"use client";

import Link from "next/link";
import type { ReactNode } from "react";

import { SidebarMenuButton } from "@/app/(application)/components/sidebar/SidebarMenuButton";
import { UserImage } from "@/app/(application)/components/sidebar/UserImage";
import { SignInButton } from "@/components/SignInButton";
import { UserNoDates } from "@/types/types";
import { cn } from "@/utils/cn";

// Normally hidden on lg+ (the desktop sidebar takes over). The TTV mobile gate sets alwaysVisible so the topbar stays available on large coarse-pointer devices (e.g. a Surface) that get the gate but still need to navigate away.
export function MobileTopbar({
  user,
  alwaysVisible = false,
  theme = "light",
  navigation = null,
  className,
}: {
  user: UserNoDates | null;
  alwaysVisible?: boolean;
  theme?: "light" | "dark";
  navigation?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "sticky top-0 z-40 flex items-center justify-between gap-x-6 px-4 py-4 sm:px-6",
        theme === "light" && "bg-white text-gray-700 shadow-sm",
        theme === "dark" && "bg-transparent text-ttvText",
        !alwaysVisible && "lg:hidden",
        className
      )}
    >
      {navigation ?? <SidebarMenuButton />}

      {user !== null ?
        <Link href="/account" className="rounded-full">
          <UserImage user={user} />
        </Link>
      : <SignInButton variant="filled" />}
    </div>
  );
}
